import { render, staticRenderFns } from "./bannerUnit.vue?vue&type=template&id=12942f8f&scoped=true"
import script from "./bannerUnit.vue?vue&type=script&lang=js"
export * from "./bannerUnit.vue?vue&type=script&lang=js"
import style0 from "./bannerUnit.vue?vue&type=style&index=0&id=12942f8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12942f8f",
  null
  
)

export default component.exports